document.addEventListener("DOMContentLoaded", function () {
  var usageLevelDropdown = document.getElementById("usageLevel");
  var additionalCampusesSection = document.getElementById("additionalCampuses");
  var additionalCampusesDrSection = document.getElementById(
    "additionalCampusesDr"
  );
  var addIntegrationsBudget = document.getElementById("addIntegrationsBudget");
  var addIntegrationsBudgetDr = document.getElementById(
    "addIntegrationsBudgetDr"
  );
  var addIntegrationsCheckbox = document.getElementById("addIntegrations");
  var addIntegrationsDrCheckbox = document.getElementById("addIntegrationsDr");
  var courseReadyCheckbox = document.getElementById("addCourseReady");
  var totalElement = document.getElementById("totalPrice");
  var versionSelectDrDropdown = document.getElementById("versionSelectDr");
  var usageLevelDrDropdown = document.getElementById("usageLevelDr");

  var prices = {
    budget: 995,
    budget_course_ready: 385,
    budget_integrations: 150,
    standard: 2150,
    standard_course_ready: 585,
    unlimited: 3350,
    unlimited_course_ready: 985,
    unlimited_extra_campus: 995,
    tafe: 5950,
    tafe_course_ready: 1285,
    tafe_extra_campus: 995,
  };

  var pricesDr = {
    budgetDr_studyDr: 995,
    budgetDr_workDr: 995,
    budgetDr_combinedDr: 1380,
    budgetDr_integrations: 150,
    standardDr_studyDr: 2150,
    standardDr_workDr: 2150,
    standardDr_combinedDr: 2635,
    unlimitedDr_studyDr: 3350,
    unlimitedDr_workDr: 3350,
    unlimitedDr_combinedDr: 4225,
    unlimitedDr_extra_campus: 995,
    tafe_collegesDr_studyDr: 5950,
    tafe_collegesDr_workDr: 5950,
    tafe_collegesDr_combinedDr: 7400,
    tafe_collegesDr_extra_campus: 995,
  };

  function updateDisplay() {
    var selectedValue = usageLevelDropdown.value;
    var selectedDrValue = usageLevelDrDropdown.value;
    var versionDrValue = versionSelectDrDropdown.value;
    var combinedSelection = `${selectedDrValue}_${versionDrValue}`;
    additionalCampusesSection.style.display =
      selectedValue === "unlimited" || selectedValue === "tafe_colleges"
        ? "flex"
        : "none";
    additionalCampusesDrSection.style.display =
      selectedDrValue === "tafe_collegesDr" || selectedDrValue === "unlimitedDr"
        ? "flex"
        : "none";
    addIntegrationsBudget.style.display =
      selectedValue === "budget" ? "flex" : "none";
    addIntegrationsBudgetDr.style.display =
      selectedDrValue === "budgetDr" ? "flex" : "none";
    calculateTotal();
    calculateTotalDr();
    updateOptionButton(selectedValue);
    updateDrOptionButton(combinedSelection);
  }

  var campusNumberInput = document.getElementById("campusNumber");

  campusNumberInput.addEventListener("input", function () {
    if (parseInt(this.value, 10) > 5) {
      this.value = 5;
    } else if (parseInt(this.value, 10) < 0) {
      this.value = 0;
    }
  });

  var campusNumberDrInput = document.getElementById("campusNumberDr");

  campusNumberDrInput.addEventListener("input", function () {
    if (parseInt(this.value, 10) > 5) {
      this.value = 5;
    } else if (parseInt(this.value, 10) < 0) {
      this.value = 0;
    }
  });

  function calculateTotal() {
    var selectedValue = usageLevelDropdown.value;
    var total = 0;
    var campusCount =
      parseInt(
        additionalCampusesSection.querySelector("input[type=number]").value,
        10
      ) || 0;

    switch (selectedValue) {
      case "budget":
        total += prices["budget"];
        if (courseReadyCheckbox.checked) total += prices["budget_course_ready"];
        if (addIntegrationsCheckbox.checked)
          total += prices["budget_integrations"];
        break;
      case "standard":
        total += prices["standard"];
        if (courseReadyCheckbox.checked)
          total += prices["standard_course_ready"];
        break;
      case "unlimited":
        total += prices["unlimited"];
        if (courseReadyCheckbox.checked)
          total += prices["unlimited_course_ready"];
        total += campusCount * prices["unlimited_extra_campus"];
        break;
      case "tafe_colleges":
        total += prices["tafe"];
        if (courseReadyCheckbox.checked) total += prices["tafe_course_ready"];
        total += campusCount * prices["tafe_extra_campus"];
        break;
      default:
        break;
    }

    if (totalElement) totalElement.textContent = "$" + total;
    updateOptionButton(selectedValue);
  }

  function calculateTotalDr() {
    var usageDrValue = document.getElementById("usageLevelDr").value;
    var versionDrValue = document.getElementById("versionSelectDr").value;
    var combinedSelection = `${usageDrValue}_${versionDrValue}`;
    var totalDr = 0;

    var campusCountDr =
      parseInt(document.getElementById("campusNumberDr").value, 10) || 0;
    var addIntegrationsDrChecked =
      document.getElementById("addIntegrationsDr").checked;

    // Base price calculation
    var basePriceKey = `${usageDrValue}_${versionDrValue}`;
    totalDr += pricesDr[basePriceKey] || 0;

    if (usageDrValue === "budgetDr" && addIntegrationsDrChecked) {
      totalDr += pricesDr.budgetDr_integrations;
    }

    if (
      (usageDrValue === "unlimitedDr" || usageDrValue === "tafe_collegesDr") &&
      campusCountDr > 0
    ) {
      totalDr += campusCountDr * pricesDr[`${usageDrValue}_extra_campus`];
    }

    document.getElementById("totalPriceDr").textContent = "$" + totalDr;
    updateDrOptionButton(combinedSelection);
  }

  function updateOptionButton(selected) {
    var buttonContainer = document.getElementById("optionButtonContainer");
    buttonContainer.innerHTML = "";
    var isCourseReadyChecked = courseReadyCheckbox.checked;
    var isIntegrationsChecked = addIntegrationsCheckbox.checked;
    var campusCount =
      parseInt(document.getElementById("campusNumber").value, 10) || 0;

    var unlimitedUrls = {
      1: isCourseReadyChecked
        ? "https://tlrg.com.au/products/lln-robot-private-rto-unlimited-package-course-ready-one-extra-campus?variant=40934695436361"
        : "https://tlrg.com.au/products/lln-robot-private-rto-unlimited-package-one-extra-campus?variant=40934683476041",
      2: isCourseReadyChecked
        ? "https://tlrg.com.au/products/lln-robot-private-rto-unlimited-package-course-ready-two-extra-campuses?variant=40934697730121"
        : "https://tlrg.com.au/products/lln-robot-private-rto-unlimited-package-two-extra-campuses?variant=40934683541577",
      3: isCourseReadyChecked
        ? "https://tlrg.com.au/products/lln-robot-private-rto-unlimited-package-course-ready-three-extra-campuses?variant=40934698713161"
        : "https://tlrg.com.au/products/lln-robot-private-rto-unlimited-package-three-extra-campuses?variant=40934683574345",
      4: isCourseReadyChecked
        ? "https://tlrg.com.au/products/lln-robot-private-rto-unlimited-package-course-ready-four-extra-campuses?variant=40934699565129"
        : "https://tlrg.com.au/products/lln-robot-private-rto-unlimited-package-four-extra-campuses?variant=40934685179977",
      5: isCourseReadyChecked
        ? "https://tlrg.com.au/products/lln-robot-private-rto-unlimited-package-course-ready-five-extra-campuses?variant=40934699597897"
        : "https://tlrg.com.au/products/lln-robot-private-rto-unlimited-package-five-extra-campuses?variant=40934685311049",
    };

    var tafeUrls = {
      1: isCourseReadyChecked
        ? "https://tlrg.com.au/products/lln-robot-tafe-college-campus-package-course-ready-one-extra-campus?variant=40934753861705"
        : "https://tlrg.com.au/products/lln-robot-tafe-college-campus-package-one-extra-campus?variant=40934723092553",
      2: isCourseReadyChecked
        ? "https://tlrg.com.au/products/lln-robot-tafe-college-campus-package-course-ready-two-extra-campuses?variant=40934754713673"
        : "https://tlrg.com.au/products/lln-robot-tafe-college-campus-package-two-extra-campuses?variant=40934724698185",
      3: isCourseReadyChecked
        ? "https://tlrg.com.au/products/lln-robot-tafe-college-campus-package-course-ready-three-extra-campuses?variant=40934756221001"
        : "https://tlrg.com.au/products/lln-robot-tafe-college-campus-package-three-extra-campuses?variant=40934724796489",
      4: isCourseReadyChecked
        ? "https://tlrg.com.au/products/lln-robot-tafe-college-campus-package-course-ready-four-extra-campuses?variant=40934756450377"
        : "https://tlrg.com.au/products/lln-robot-tafe-college-campus-package-four-extra-campuses?variant=40934724862025",
      5: isCourseReadyChecked
        ? "https://tlrg.com.au/products/lln-robot-tafe-college-campus-package-course-ready-five-extra-campuses?variant=40934758121545"
        : "https://tlrg.com.au/products/lln-robot-tafe-college-campus-package-five-extra-campuses?variant=40934726336585",
    };

    var urls = {
      budget: isCourseReadyChecked
        ? isIntegrationsChecked
          ? "https://tlrg.com.au/products/lln-robot-with-course-ready-private-rto-budget-package-lln-robot-api?variant=40934661292105"
          : "https://tlrg.com.au/products/lln-robot-with-course-ready-private-rto-budget-package"
        : isIntegrationsChecked
        ? "https://tlrg.com.au/products/copy-of-lln-robot-private-rto-budget-package?_pos=1&_sid=b87503bd6&_ss=r"
        : "https://tlrg.com.au/products/private-rto-budget-package",
      standard: isCourseReadyChecked
        ? "https://tlrg.com.au/products/lln-robot-with-course-ready-private-rto-standard-package"
        : "https://tlrg.com.au/products/lln-robot-private-rto-standard-package",
      unlimited:
        campusCount >= 1 && campusCount <= 5
          ? unlimitedUrls[campusCount]
          : isCourseReadyChecked
          ? "https://tlrg.com.au/products/lln-robot-with-course-ready-private-rto-unlimited-package"
          : "https://tlrg.com.au/products/private-rto-unlimited-package",
      tafe_colleges:
        campusCount >= 1 && campusCount <= 5
          ? tafeUrls[campusCount]
          : isCourseReadyChecked
          ? "https://tlrg.com.au/products/lln-robot-with-course-ready-tafe-college-campus-package"
          : "https://tlrg.com.au/products/tafe-college-unlimited-package",
    };

    if (
      ["budget", "standard", "unlimited", "tafe_colleges"].includes(selected)
    ) {
      var button = document.createElement("button");
      button.textContent = "Buy Now";
      button.style.cssText =
        "text-transform: capitalize !important; text-align: center; cursor: pointer;";

      button.onclick = function () {
        window.open(urls[selected], "_blank");
      };
      buttonContainer.appendChild(button);
    }
  }

  function updateDrOptionButton(combinedSelection) {
    var buttonContainer = document.getElementById("optionButtonContainerDr");
    buttonContainer.innerHTML = "";
    var campusCount =
      parseInt(document.getElementById("campusNumberDr").value, 10) || 0;
    var isIntegrationsChecked =
      document.getElementById("addIntegrationsDr").checked;

    var urls = {
      budgetDr_studyDr: isIntegrationsChecked
        ? "https://tlrg.com.au/products/digital-robot-study-budget-integrations"
        : "https://tlrg.com.au/products/digital-robot-study-budget",
      budgetDr_workDr: isIntegrationsChecked
        ? "https://tlrg.com.au/products/digital-robot-work-budget-integrations"
        : "https://tlrg.com.au/products/digital-robot-work-budget",
      budgetDr_combinedDr: isIntegrationsChecked
        ? "https://tlrg.com.au/products/digital-robot-study-work-budget-integrations"
        : "https://tlrg.com.au/products/digital-robot-study-work-budget",
      standardDr_studyDr:
        "https://tlrg.com.au/products/digital-robot-study-standard",
      standardDr_workDr:
        "https://tlrg.com.au/products/digital-robot-work-standard",
      standardDr_combinedDr:
        "https://tlrg.com.au/products/digital-robot-study-work-standard",
      unlimitedDr_studyDr:
        "https://tlrg.com.au/products/digital-robot-study-unlimited",
      unlimitedDr_studyDr_1:
        "https://tlrg.com.au/products/digital-robot-study-unlimited-one-extra-site",
      unlimitedDr_studyDr_2:
        "https://tlrg.com.au/products/digital-robot-study-unlimited-two-extra-sites",
      unlimitedDr_studyDr_3:
        "https://tlrg.com.au/products/digital-robot-study-unlimited-three-extra-sites",
      unlimitedDr_studyDr_4:
        "https://tlrg.com.au/products/digital-robot-study-unlimited-four-extra-sites",
      unlimitedDr_studyDr_5:
        "https://tlrg.com.au/products/digital-robot-study-unlimited-five-extra-sites",
      unlimitedDr_workDr:
        "https://tlrg.com.au/products/digital-robot-work-unlimited",
      unlimitedDr_workDr_1:
        "https://tlrg.com.au/products/digital-robot-work-unlimited-one-extra-site",
      unlimitedDr_workDr_2:
        "https://tlrg.com.au/products/digital-robot-work-unlimited-two-extra-sites",
      unlimitedDr_workDr_3:
        "https://tlrg.com.au/products/digital-robot-work-unlimited-three-extra-sites",
      unlimitedDr_workDr_4:
        "https://tlrg.com.au/products/digital-robot-work-unlimited-four-extra-sites",
      unlimitedDr_workDr_5:
        "https://tlrg.com.au/products/digital-robot-work-unlimited-five-extra-sites",
      unlimitedDr_combinedDr:
        "https://tlrg.com.au/products/digital-robot-study-work-unlimited",
      unlimitedDr_combinedDr_1:
        "https://tlrg.com.au/products/digital-robot-study-work-unlimited-one-extra-site",
      unlimitedDr_combinedDr_2:
        "https://tlrg.com.au/products/digital-robot-study-work-unlimited-two-extra-sites",
      unlimitedDr_combinedDr_3:
        "https://tlrg.com.au/products/digital-robot-study-work-unlimited-three-extra-sites",
      unlimitedDr_combinedDr_4:
        "https://tlrg.com.au/products/digital-robot-study-work-unlimited-four-extra-sites",
      unlimitedDr_combinedDr_5:
        "https://tlrg.com.au/products/digital-robot-study-work-unlimited-five-extra-sites",
      tafe_collegesDr_studyDr:
        "https://tlrg.com.au/products/digital-robot-study-tafe",
      tafe_collegesDr_studyDr_1:
        "https://tlrg.com.au/products/digital-robot-study-tafe-one-extra-site",
      tafe_collegesDr_studyDr_2:
        "https://tlrg.com.au/products/digital-robot-study-tafe-two-extra-sites",
      tafe_collegesDr_studyDr_3:
        "https://tlrg.com.au/products/digital-robot-study-tafe-three-extra-sites",
      tafe_collegesDr_studyDr_4:
        "https://tlrg.com.au/products/digital-robot-study-tafe-four-extra-sites",
      tafe_collegesDr_studyDr_5:
        "https://tlrg.com.au/products/digital-robot-study-tafe-five-extra-sites",
      tafe_collegesDr_workDr:
        "https://tlrg.com.au/products/digital-robot-work-tafe",
      tafe_collegesDr_workDr_1:
        "https://tlrg.com.au/products/digital-robot-work-tafe-one-extra-site",
      tafe_collegesDr_workDr_2:
        "https://tlrg.com.au/products/digital-robot-work-tafe-two-extra-sites",
      tafe_collegesDr_workDr_3:
        "https://tlrg.com.au/products/digital-robot-work-tafe-three-extra-sites",
      tafe_collegesDr_workDr_4:
        "https://tlrg.com.au/products/digital-robot-work-tafe-four-extra-sites",
      tafe_collegesDr_workDr_5:
        "https://tlrg.com.au/products/digital-robot-work-tafe-five-extra-sites",
      tafe_collegesDr_combinedDr:
        "https://tlrg.com.au/products/digital-robot-study-work-tafe",
      tafe_collegesDr_combinedDr_1:
        "https://tlrg.com.au/products/digital-robot-study-work-tafe-one-extra-site",
      tafe_collegesDr_combinedDr_2:
        "https://tlrg.com.au/products/digital-robot-study-work-tafe-two-extra-sites",
      tafe_collegesDr_combinedDr_3:
        "https://tlrg.com.au/products/digital-robot-study-work-tafe-three-extra-sites",
      tafe_collegesDr_combinedDr_4:
        "https://tlrg.com.au/products/digital-robot-study-work-tafe-four-extra-sites",
      tafe_collegesDr_combinedDr_5:
        "https://tlrg.com.au/products/digital-robot-study-work-tafe-five-extra-sites",
    };

    var urlKey = combinedSelection;
    if (
      (combinedSelection === "unlimitedDr_studyDr" ||
        combinedSelection === "unlimitedDr_workDr" ||
        combinedSelection === "unlimitedDr_combinedDr" ||
        combinedSelection === "tafe_collegesDr_studyDr" ||
        combinedSelection === "tafe_collegesDr_workDr" ||
        combinedSelection === "tafe_collegesDr_combinedDr") &&
      campusCount > 0
    ) {
      urlKey = `${combinedSelection}_${campusCount}`;
    }

    var url = urls[urlKey];

    if (url) {
      var button = document.createElement("button");
      button.textContent = "Buy Now";
      button.style.cssText =
        "text-transform: capitalize !important; text-align: center; cursor: pointer;";

      button.onclick = function () {
        window.open(url, "_blank");
      };
      buttonContainer.appendChild(button);
    }
  }

  usageLevelDropdown.addEventListener("change", updateDisplay);
  usageLevelDrDropdown.addEventListener("change", updateDisplay);
  versionSelectDrDropdown.addEventListener("change", updateDisplay);
  addIntegrationsCheckbox.addEventListener("change", calculateTotal);
  addIntegrationsDrCheckbox.addEventListener("change", calculateTotalDr);
  courseReadyCheckbox.addEventListener("change", calculateTotal);
  additionalCampusesSection
    .querySelector("input[type=number]")
    .addEventListener("input", calculateTotal);
  additionalCampusesDrSection
    .querySelector("input[type=number]")
    .addEventListener("input", calculateTotalDr);

  var defaultUsageDrValue = usageLevelDrDropdown.value;
  var defaultVersionDrValue = versionSelectDrDropdown.value;
  var defaultCombinedSelection = `${defaultUsageDrValue}_${defaultVersionDrValue}`;

  updateDisplay();
  updateDrOptionButton(defaultCombinedSelection);
});

var acc = document.getElementsByClassName("product-accordion");

Array.from(acc).forEach(function (accordion) {
  var panel = accordion.nextElementSibling;
  panel.style.maxHeight = "0";
  panel.style.opacity = "0";
  panel.style.display = "none";
});

for (var i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    var panel = this.nextElementSibling;
    var expandSign = this.querySelector(".expand-sign");

    if (panel.style.display === "block") {
      panel.style.opacity = "0";
      panel.style.maxHeight = "0";
      setTimeout(
        (function (panel, expandSign) {
          return function () {
            panel.style.display = "none";
            expandSign.textContent = "+";
          };
        })(panel, expandSign),
        400
      );
    } else {
      panel.style.display = "block";
      setTimeout(
        (function (panel, expandSign) {
          return function () {
            panel.style.maxHeight = panel.scrollHeight + "px";
            panel.style.opacity = "1";
            expandSign.textContent = "-";
          };
        })(panel, expandSign),
        10
      );
    }
  });
}

function validateField(field) {
  var value = field.value.trim();
  hideWarning(field.id);

  if (!value) {
    showWarning(field.id, "This field is required");
    return false;
  }

  if (field.type === "email" && !isValidEmail(value)) {
    showWarning(field.id, "Invalid email address");
    return false;
  }

  if (field.id === "trial_phone" && !isValidPhone(value)) {
    showWarning(field.id, "Invalid number");
    return false;
  }

  return true;
}

function isValidEmail(email) {
  var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

function isValidPhone(phone) {
  var phoneRegex = /^[+\d\s().-]+$/;
  return phoneRegex.test(phone);
}

function showWarning(fieldId, message) {
  var warningId = "warning_" + fieldId;
  var warningSpan = document.getElementById(warningId);
  if (warningSpan) {
    warningSpan.textContent = message;
    warningSpan.style.display = "inline";
  }
}

function hideWarning(fieldId) {
  var warningId = "warning_" + fieldId;
  var warningSpan = document.getElementById(warningId);
  if (warningSpan) {
    warningSpan.style.display = "none";
  }
}

function areAllFieldsFilled() {
  var fields = document.querySelectorAll(
    "#free-trial-section .form-control[required]"
  );
  var allValid = true;
  for (var i = 0; i < fields.length; i++) {
    var value = fields[i].value.trim();
    hideWarning(fields[i].id);
    if (!value) {
      showWarning(fields[i].id, "This field is required");
      allValid = false;
      continue;
    }
    if (fields[i].id === "trial_email" && !isValidEmail(value)) {
      showWarning(fields[i].id, "Invalid email address");
      allValid = false;
    }
    if (fields[i].id === "trial_phone" && !isValidPhone(value)) {
      showWarning(fields[i].id, "Invalid number");
      allValid = false;
    }
  }
  var recaptchaResponse = grecaptcha.getResponse();
  if (recaptchaResponse.length === 0) {
    allValid = false;
  }
  return allValid;
}

function enableFreeTrial() {
  var fieldsFilled = areAllFieldsFilled();
  document.getElementById("btnFreeTrial").disabled = !fieldsFilled;
}
document.addEventListener("DOMContentLoaded", function () {
  var freeTrialSection = document.getElementById("free-trial");
  var btn = document.getElementById("tab1");
  var btnDigital = document.getElementById("tab2");
  var trialType = "Digital"; // Initialize as Digital

  function updateSectionForTrialType(type) {
    var form = freeTrialSection.querySelector("form");
    var title = freeTrialSection.querySelector("h1");
    var trialDescription = freeTrialSection.querySelector("#free-trial p");
    title.textContent = `Discover More with a Free 3 Week ${type} Trial`;
    trialDescription.textContent = `Try the ${type} Robot for yourself`;

    var existingTypeInput = form.querySelector('input[name="type"]');
    if (existingTypeInput) {
      existingTypeInput.remove();
    }

    var input = document.createElement("input");
    input.setAttribute("type", "hidden");
    input.setAttribute("name", "type");
    input.value = type.toLowerCase();
    form.appendChild(input);
  }

  if (btn) {
    btn.addEventListener("click", function () {
      trialType = "LLN";
      updateSectionForTrialType(trialType);
    });
  }

  if (btnDigital) {
    btnDigital.addEventListener("click", function () {
      trialType = "Digital";
      updateSectionForTrialType(trialType);
    });
  }

  updateSectionForTrialType(trialType); // Set initial state to Digital

  var requiredFields = freeTrialSection.querySelectorAll(
    ".form-control[required]"
  );
  requiredFields.forEach(function (field) {
    field.addEventListener("input", function () {
      validateField(field);
      enableFreeTrial();
    });
  });
});

var openSectionLink = document.getElementById("openSectionLink");
var openSectionLinkTwo = document.getElementById("openSectionLinkTwo");

openSectionLink.onclick = function (event) {
  event.preventDefault();
  freeTrialSection.scrollIntoView({ behavior: "smooth" });
};

openSectionLinkTwo.onclick = function (event) {
  event.preventDefault();
  freeTrialSection.scrollIntoView({ behavior: "smooth" });
};

document.getElementById("hidden_iframe").onload = function () {
  var message = trialType === "Digital" ? "Digital Robot" : "LLN Robot";
  alert(
    `Thank you for applying for a trial to ${message}. Our team will review the application and notify you via email if it has been approved.`
  );
};
